import { FC, useContext } from 'react';
import { Stack, Typography } from '@mui/material';
import { AuthenticationContext } from '@vs-online-only-app/state';
import ChatRating from './ChatRating';

const HomeHeader: FC = () => {
  const { user } = useContext(AuthenticationContext);

  return (
    <Stack pb={3}>
      <Typography variant="h2">
        Hi{user?.firstName ? `, ${user.firstName}` : ''}
      </Typography>
      <ChatRating />
    </Stack>
  );
};

export default HomeHeader;
